import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { ICmsAboutTravelPass, ICmsAboutPassResponse } from "../../Orchestrator/Types/Interface/ICMSOffers";

export const getAboutTravelPass = async () => {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCmsAboutTravelPassAPI;

  const params = new URLSearchParams();
  const locale = await getLocaleFromCookie();

  params.append("locale", locale);
  params.append("populate", "image");

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsAboutPassResponse<ICmsAboutTravelPass>>(
    endpointWithParams,
    "GET"
  );
}